/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Input, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";

import { ObjectService } from "app/services/object.service";
import { ObjectCategory } from "../models/object-category";
import { ObjectProperty } from "app/models/object-property";

@Injectable({providedIn: 'root'})
export class AssetPropertiesMainDisplayResolver implements Resolve<ObjectProperty[]> {

  constructor(
    private mObjectService: ObjectService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ObjectProperty[]> {
    try {
        return this.mObjectService.getAllPropertiesForMainDisplayAndCategory(ObjectCategory.ASSET);
    } catch (error) {
        console.error("Problem obtaining Asset Properties for Main Display...", error);
        return [];
    }
  }

}
